export default __webpack_public_path__ + "static/background-image-6a3ece74161adf62e762aa9700d2c0dd.gif";